<template>
  <div>
    <div class="slogan">
      <p>答卷已提交，请查看系统评分、教师评分与最终成绩。</p>
    </div>
    <el-container class="app-item-contain">
      <el-header class="align-center">
        <h1 style="font-size: 30px;">{{ form.paper.name }}</h1>
        <br>
        <br>
        <span style="float: left; margin-top: -75px; ">
          <el-tag type="info" size="normal" style="font-weight: bold">系统评分: {{ form.sys_score }}</el-tag>
        </span>
        <span style="float: left; margin-top: -35px;">
          <el-tag type="primary" size="normal" style="font-weight: bold">教师评分: {{ form.hand_score }}</el-tag>
        </span>
        <span style="float: left; margin-top: 5px;">
          <el-tag type="success" size="normal" style="font-weight: bold">最终成绩: {{ form.final_score }}</el-tag>
        </span>
        试卷总分: <span style="color: red;" class="sec-title">{{ form.paper.paper_score }}</span>
        <span class="sec-title">所属学科: {{ form.paper.subject_name }}</span>
        <span class="sec-title">考试时长: {{ form.task_duration }}min</span>
        <span class="sec-title">考试类型: {{ form.type_name }}</span>
        <span style="float: right; font-size: 20px;">
          考生姓名: &nbsp;&nbsp;<span style="color:darkblue">{{ form.student_name }}</span>
        </span>
        <br>
        <el-divider></el-divider>
      </el-header>
      <br>
      <br>
      <br>
      <el-main>
        <el-form :model="form" ref="form" v-loading="formLoading" label-width="100px">
          <el-row :key="index" v-for="(topic,index) in form.paper.topicItem">
            <h3>{{ topic.content }}</h3>
            <el-card class="exampaper-item-box" v-if="topic.titles.length!==0">
              <el-form-item :key="title.id" :label="index + 1 + '.'"
                            v-for="(title, index) in topic.titles"
                            class="exam-question-item" label-width="50px" :id="'question-'+ index">
                <StudentCheckTitle :qType="title.title_type" :question="title"/>
              </el-form-item>
            </el-card>
          </el-row>
        </el-form>
      </el-main>
    </el-container>
    <div class="back-btn">
      <el-button icon="el-icon-d-arrow-left" type="primary" style="font-size: 16px;" @click="goIndex">返回首页</el-button>
    </div>
    <div class="app-footer">© 海之林科技 在线考试系统</div>
  </div>
</template>

<script>
import StudentCheckTitle from "../../components/StudentCheckTitle";

export default {
  name: 'ReadPaper',
  components: {StudentCheckTitle,},
  data() {
    return {
      form: {
        paper: {
          name: '',
          paper_score: '',
        }
      },
      formLoading: false,
    }
  },
  created() {
    let id = this.$route.query.id
    if (id && parseInt(id) !== 0) {
      this.formLoading = true
      this.$http({
        url: this.$settings.BASE_URL + `/paper/student_paper/get_paper/`,
        params: {paper_id: id},
        method: 'get',
      }).then(res => {
        if (res.data.code === 20000) {
          this.form = res.data.result
          this.formLoading = false
        }else{
          this.$message({
            type: 'error',
            message: '获取试卷失败,或试卷已删除',
            duration: 5000,
            onClose:()=>{
              this.goIndex()
            }
          })
        }
      })
    }
  },
  methods: {
    goIndex() {
      this.$router.push('/StudentIndex')
    },
  },
  computed: {}
}
</script>

<style lang="css" scoped>

.back-btn {
  height: 80px;
  margin-top: 20px;
  margin-left: 695px;
}

.align-center {
  text-align: center
}

.exam-question-item {
  padding: 10px;
}

.el-form-item__label {
  font-size: 15px !important;
}


.question-title-padding {
  padding-left: 25px;
  padding-right: 25px;
}

.sec-title {
  margin-right: 50px;
  font-weight: normal;
}

.slogan {
  background-color: #eee;
  height: 40px;
}

.slogan p {
  width: 1200px;
  margin: 0 auto;
  color: #aaa;
  font-size: 13px;
  line-height: 40px;
}

</style>
